import type { PaymentAdapter } from "./customGatewayAdapter";
import { normalizeResponse } from "../core/normalizeResponse";

export const iframeAdapter: PaymentAdapter = async (session, input) => {
  const url = session.checkoutUrl ?? session.redirectUrl;

  if (!url) {
    return normalizeResponse({
      status: "pending",
      input,
      rawResponse: session,
      message: "Payment session created"
    });
  }

  return normalizeResponse({
    status: "pending",
    input,
    rawResponse: { ...session, iframeUrl: url },
    message: "Payment iframe session is ready"
  });
};
